/**
 * ¿SE PUEDE BLOQUEAR DE VERDAD, O SÓLO SILENCIAR?
 *
 * POR QUÉ IMPORTA LA PALABRA (10-sep-2026)
 * ────────────────────────────────────────
 * Son dos cosas distintas y el botón tiene que decir cuál está haciendo:
 *
 *   · BLOQUEAR  — llamada a `{phone-number-id}/block_users`. La persona **no puede
 *                 escribir**: el mensaje no llega ni al inbox.
 *   · SILENCIAR — sólo el marcador local. El asistente calla, pero **la persona sigue
 *                 escribiendo** y sus mensajes siguen entrando en la bandeja.
 *
 * Llamar «Bloquear» a lo segundo es prometer algo que no ocurre, y el usuario lo
 * descubre cuando ve llegar mensajes de alguien a quien creía bloqueado. Se detectó
 * exactamente así: la UI pedía el marcador y no el bloqueo real, el bot callaba y los
 * mensajes seguían apareciendo.
 *
 * LAS TRES CONDICIONES SON LAS MISMAS QUE EXIGE EL BACKEND
 * ───────────────────────────────────────────────────────
 * `functions/callable/bloquearContacto.js` valida canal, `numeroId` y `telefono` y
 * devuelve 400 si falta alguno. Aquí se replican para elegir la PALABRA, no para
 * autorizar: el backend sigue siendo la autoridad y valida por su cuenta. Si las dos
 * listas divergieran, el síntoma sería un botón que dice «Bloquear» y un error al
 * pulsarlo — molesto, pero no una brecha.
 *
 * Hoy afecta a 45 de 217 chats: los 26 de TikTok (su API no tiene bloqueo), los 17 de
 * Instagram y el 1 de Messenger (pendientes de su propia pieza), y 1 de WhatsApp sin
 * `numeroId`.
 */

/**
 * @param {object} chat el documento del chat
 * @returns {boolean} true si el canal admite bloqueo aguas arriba Y hay datos para pedirlo
 */
export function admiteBloqueoReal(chat) {
  if (!chat) return false;
  if (chat.canal !== 'whatsapp') return false;
  // Sin `numeroId` no hay `phone-number-id` que pasarle a Meta.
  if (!chat.numeroId) return false;
  // Sin teléfono no hay a quién bloquear: `bsuid` no sirve para `block_users`.
  if (!chat.telefono) return false;
  return true;
}

/** El sufijo de las claves de i18n, para no repetir el ternario en cada texto. */
export function sufijoDeTexto(chat) {
  return admiteBloqueoReal(chat) ? 'Block' : 'Silence';
}
